@if (node | async; as item) {
  <section class="col-xs-12" id="home_solutionssection" [ngClass]="{'home_solutionssection-uk':item.uid=='SeqirusUKFlu360Solutions-OverviewComponent'}">
    <div [innerHTML]="safeh2content"></div>
    <div id="home_solutiontabs">
      @for (banner of banners | slice:0:3; track banner; let i = $index) {
        <div class="col-xs-12 col-md-4" [ngClass]="{'card-expand':show[i]==true,'card-collapse':show[i]==false,'home_tabs-uk':item.uid=='SeqirusUKFlu360Solutions-OverviewComponent','home_tabs':item.uid=='Flu360Solutions-OverviewComponent'}">
          <div class="sloutions_tabs">
            @if (item.uid!='Flu360Solutions-CarouselComponent') {
              <div class="solutions--btn">
                <div class="solutions--hitarea"></div>
                <img class="expand--btn" alt="Expand" [ngClass]="show[i]?'not-active':''" src="../../../../assets/images/card-expand-btn.svg" (click)="onClick(i)">
                <img class="collapse--btn" alt="Collapse" [ngClass]="show[i]?'':'not-active'" src="../../../../assets/images/collapse-btn.svg" (click)="onClick(i)">
              </div>
            }
            <div class="solutions--card-container">
              <div class="home_tabsimg" id="home_tabimg{{i}}"
              style="background-image: url('{{ getMediaUrl(banner.media) }}');"></div>
              <div class="home_tabsheader" id="home_tabheader{{i}}">{{banner.h2content}}</div>
              <div class="home_tabscontent">{{banner.paragraphcontent}}</div>
              <div class="content--expand oversectionUK expand--content" [ngClass]="show[i]?'':'not-active'" >
                <div  [innerHTML]="banner.content">
                </div>
                <a class="link1" [routerLink]="banner.headline">{{banner.largeparagraphcontent}}<img class="overview-arrow" alt="Next screen" src="../../../../app/../assets/images/blackarrow.png"></a>
              </div>
            </div>
          </div>
        </div>
      }
    </div>
    <div class="col-xs-12 global_greybtncontainer" [innerHTML]="paracontent" appRouterlinkinterceptor>
    </div>
  </section>
}
